import React from "react";
import { Link } from "react-router-dom";
import styles from "./reader.module.css";

export default function NextPrevBar({ backToCourse, prevPath, nextPath }) {
  return (
    <div className={styles.btnRow}>
      <Link to={backToCourse} className={`${styles.btn} ${styles.ghost}`}>Volver al Libro</Link>
      <div style={{display:"flex", gap:8}}>
        {prevPath && <Link to={prevPath} className={`${styles.btn} ${styles.ghost}`}>Lección anterior</Link>}
        {nextPath && <Link to={nextPath} className={`${styles.btn} ${styles.primary}`}>Siguiente Lección</Link>}
      </div>
    </div>
  );
}
